export default {
  loans: []
};



// WEBPACK FOOTER //
// ./src/utils/packages.js